<div class="timer-countdown">
  <!-- DAYS -->
  <div class="timer-unit" [style.--progress]="dayProgress">
    <svg class="timer-ring" width="120" height="120">
      <circle class="timer-ring-bg" cx="60" cy="60" r="52"></circle>
      <circle class="timer-ring-progress" cx="60" cy="60" r="52"></circle>
    </svg>

    <div class="timer-content">
      <span class="timer-value">{{ days }}</span>
      <div class="timer-label">Days</div>
    </div>
  </div>

  <!-- HOURS -->
  <div class="timer-unit" [style.--progress]="hourProgress">
    <svg class="timer-ring" width="120" height="120">
      <circle class="timer-ring-bg" cx="60" cy="60" r="52"></circle>
      <circle class="timer-ring-progress" cx="60" cy="60" r="52"></circle>
    </svg>

    <div class="timer-content">
      <span class="timer-value">{{ hours }}</span>
      <div class="timer-label">Hours</div>
    </div>
  </div>

  <!-- MINUTES -->
  <div class="timer-unit" [style.--progress]="minuteProgress">
    <svg class="timer-ring" width="120" height="120">
      <circle class="timer-ring-bg" cx="60" cy="60" r="52"></circle>
      <circle class="timer-ring-progress" cx="60" cy="60" r="52"></circle>
    </svg>

    <div class="timer-content">
      <span class="timer-value">{{ mins }}</span>
      <div class="timer-label">Minutes</div>
    </div>
  </div>

  <!-- SECONDS -->
  <div class="timer-unit" [style.--progress]="secondProgress">
    <svg class="timer-ring" width="120" height="120">
      <circle class="timer-ring-bg" cx="60" cy="60" r="52"></circle>
      <circle class="timer-ring-progress" cx="60" cy="60" r="52"></circle>
    </svg>

    <div class="timer-content">
      <span class="timer-value">{{ secs }}</span>
      <div class="timer-label">Seconds</div>
    </div>
  </div>
</div>